import {FACTIONS} from "../../../constants/factions";
import {isUnitFaction} from "../isUnitFaction";

export const isCombatVersusDemons = (enemyUnits) => {
  return enemyUnits.some(enemyUnit => isUnitFaction(enemyUnit, FACTIONS.DEMONS))
}